import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { ProductAdmin } from '../../../interfaces/Producto/ProductAdmin'
import { VasRule, VasRuleLog } from '../../../interfaces/VasRule/VasRule'
import { Tooltip, Typography } from '@mui/material'
import { utcToLocal } from '../../../utils/dateHelper'
import { eTypeAction } from '../../../enums/eTypeActyon'
import { YesNoBadge } from '../../../components/YesNoBadge'

export const getColumnsConfig = (): TableColumn<ProductAdmin>[] => [
  { key: 'sku', title: 'SKU', sortable: true },
  { key: 'ean13', title: 'EAN13' },

  { key: 'productOriginName', title: 'Marca' },
  {
    key: 'withVas',
    title: 'Con VAS',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  },
  {
    key: 'externalStorage',
    title: 'Almacenamiento Externo',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]

export const getColumnsConfigVas = (): TableColumn<VasRule>[] => [
  {
    key: 'name',
    title: 'Nombre',
    align: 'left',
    render: (value: unknown) => {
      const text = (value as string) || ''

      return (
        <Tooltip title={text}>
          <Typography
            noWrap
            variant='body2'
            style={{
              maxWidth: 200,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'inline-block',
              verticalAlign: 'middle'
            }}
          >
            {text}
          </Typography>
        </Tooltip>
      )
    }
  },
  { key: 'typeVasName', title: 'Tipo' },
  {
    key: 'active',
    title: 'Activo',
    render: (value: unknown) => (
      <YesNoBadge value={value as boolean} yesText='Activo' noText='Inactivo' />
    )
  }
]


const getActionColor = (accion: number) => {
  switch (accion) {
    case eTypeAction.Creación:
      return { backgroundColor: '#e8f5e9', colorText: '#2e7d32' }
    case eTypeAction.Eliminación:
      return { backgroundColor: '#ffebee', colorText: '#c62828' }
    case eTypeAction.Modificación:
      return { backgroundColor: '#e3f2fd', colorText: '#1565c0' }
    default:
      return { backgroundColor: '#f5f5f5', colorText: '#616161' }
  }
}

export const getVasRuleLogColumnsConfig = (): TableColumn<VasRuleLog>[] => [
  { key: 'createdAt', title: 'Fecha', render: (value: unknown) =>
          utcToLocal(value as string, 'dd-MM-yyyy') },
  { key: 'createdAt', title: 'Hora', render: (value: unknown) =>
          utcToLocal(value as string, 'HH:mm:ss') },
  { key: 'vasRuleName', title: 'Regla VAS' },
  { key: 'userName', title: 'Usuario' },
  {
    key: 'typeActionId' as keyof VasRuleLog,
    title: 'Acción',
    render: (value: unknown) => {
      const { backgroundColor, colorText } = getActionColor(value as number)

      return (
        <div
          style={{
            display: 'inline-block',
            minWidth: 50, // Tamaño fijo mínimo
            textAlign: 'center', // Centra el texto dentro
            borderRadius: '12px',
            padding: '2px 8px',
            fontSize: '11px',
            fontWeight: 'bold',
            backgroundColor,
            color: colorText,
            whiteSpace: 'nowrap', // Evita que el texto se corte
            boxShadow: '0 2px 2px rgba(0,0,0,0.15)'
          }}
        >
          {eTypeAction[value as number] || ''}
        </div>
      )
    }
  }
]
